module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "blockquote"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm06"
    }
  }), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _c('em', [_vm._v("‘And he laid hold on the dragon, that old serpent, which is the Devil, and Satan, and bound him a thousand years.’")])]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_c('em', [_vm._v("Revelation 20:2")]), _c('a', {
    attrs: {
      "id": "page_6"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-323d3a79","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm06.vue
// module id = 78
// module chunks = 0